import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'cftProProfileLogoAltText',
  pure: true,
  standalone: true,
})
export class ProProfileLogoAltTextPipe implements PipeTransform {
  transform(pro: {
    companyName: string
    locations: {
      place: {
        locality: string
      }
    }[]
  }) {
    const location = pro.locations[0]
    return `${pro.companyName}${location ? ` – ${location.place.locality}` : ''}`
  }
}
